<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="资金明细类型：" prop="item_key">
                    <el-select v-model="form.item_key" placeholder="" clearable>
                        <el-option v-for="item in ITEM_KEY_OPTIONS" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="币种：" prop="currency">
                    <el-select v-model="form.currency" placeholder="" clearable>
                        <el-option v-for="item in currencyOptions()" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini" :row-key="rowKey">
            <el-table-column label="编号" width="320">
                <template v-slot="scope">
                    <span>{{ scope.row.record_no }}</span>
                </template>
            </el-table-column>
            <el-table-column label="时间" width="200">
                <template v-slot="scope">
                    {{
                        scope.row.created_time
                            ? dayjs(scope.row.created_time).format('YYYY-MM-DD HH:mm:ss.SSS')
                            : ''
                    }}
                </template>
            </el-table-column>
            <el-table-column label="商户CODE">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="企业名称">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="资金明细类型" width="320">
                <template v-slot="scope">
                    <span>{{ itemKeyLabel(scope.row.item_key) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="金额">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="余额">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.balance_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="currency" label="币种" />
            <el-table-column label="类型">
                <template v-slot="scope">
                    <span>{{ scope.row.type === 1 ? "增加" : scope.row.type === 2 ? "减少" : "" }}</span>
                </template>
            </el-table-column>
            <el-table-column label="描述">
                <template v-slot="scope">
                    <span>{{ scope.row.description }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
    </div>
</template>

<script>
import { onMounted, ref, toRaw, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'
import dayjs from 'dayjs'
import { ITEM_KEY_OPTIONS, currencyOptions, itemKeyLabel, formatAmount } from '../../../util/salesPartner'

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const form = reactive({
            partner_code: '',
            item_key: '',
            currency: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])

        // 流水 record_no 不再唯一，用 record_no + item_key + currency 组合成唯一行标识
        const rowKey = (row) => `${row.record_no}_${row.item_key}_${row.currency}`

        const goback = () => {
            router.go(-1)
        }

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerFundsAccountRecordList({
                ...toRaw(form),
                // 未选币种时不传该参数，避免后端按空串过滤
                currency: form.currency || undefined,
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        onMounted(() => {
            const partner_code = route.params.partner_code
            if (partner_code) {
                form.partner_code = partner_code
                onSearch()
            }
        })

        return {
            goback,
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            resetForm,
            rowKey,
            ITEM_KEY_OPTIONS,
            currencyOptions,
            itemKeyLabel,
            formatAmount,
            dayjs
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>